import * as React from "react";
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography, Skeleton } from "@mui/material";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserProvider";
import { useAlert } from "../contexts/AlertProvider";
import { API_BASE_URL } from "../config";
import { useTokens } from "../theme";

export default function Breadcrumbs() {
  const tokens = useTokens();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { id } = useUser();
  const { alert } = useAlert();
  const [agentName, setAgentName] = React.useState("");

  const paramId = searchParams.get("id");
  const isViewingOtherAgent =
    location.pathname.startsWith("/clientDashboard") &&
    paramId &&
    Number(paramId) !== Number(id);
  const fromLabel = location.state?.from;
  const tabLabel = searchParams.get("tab") === "groups" ? "Groups" : "Individual policies";

  React.useEffect(() => {
    if (!isViewingOtherAgent) {
      return;
    }

    const fetchAgentName = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/agents/details/${paramId}/v1`);
        const result = await response.json();
        setAgentName(`${result.firstName} ${result.lastName}`);
      } catch (error) {
        alert({
          title: "Error Occurred",
          detail: "Unable to retrieve agent data at the moment",
          severity: "error",
          duration: 5000,
        });
      }
    };

    fetchAgentName();
  }, [paramId, isViewingOtherAgent, alert]);

  if (!isViewingOtherAgent) {
    return null;
  }

  return (
    <MuiBreadcrumbs
      aria-label="breadcrumb"
      separator="›"
      sx={{
        width: "100%",
        boxSizing: "border-box",
        marginBottom: "12px",
        padding: "8px 14px",
        borderRadius: `${tokens.radius}px`,
        bgcolor: tokens.card,
        border: `1px solid ${tokens.border}`,
        "& .MuiBreadcrumbs-separator": { color: tokens.mutedForeground },
      }}
    >
      <Link
        component="button"
        underline="hover"
        onClick={() => navigate(-1)}
        sx={{ color: tokens.mutedForeground, fontWeight: 500, fontSize: "14px" }}
      >
        {fromLabel || "Back"}
      </Link>
      {agentName ? (
        <Typography sx={{ color: tokens.mutedForeground, fontWeight: 500, fontSize: "14px" }}>
          {agentName}
        </Typography>
      ) : (
        <Skeleton width={90} aria-label="Loading agent name" />
      )}
      <Typography sx={{ color: tokens.foreground, fontWeight: 600, fontSize: "14px" }}>
        {tabLabel}
      </Typography>
    </MuiBreadcrumbs>
  );
}
